import { render } from "./Histories.vue?vue&type=template&id=48c42428"
import script from "./Histories.vue?vue&type=script&lang=js"
export * from "./Histories.vue?vue&type=script&lang=js"
script.render = render

export default script